var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay",class:{'active': (_vm.props.activeMenu)},on:{"click":function($event){return _vm.props.toggleMenu()}}})}
var staticRenderFns = []

export { render, staticRenderFns }